import axios from "axios";
import { partnersList } from "../config/partners";
import { endpoint, ipAddressURL } from "./../config";

// validate if the date is valid/in range of caledar
export const isValidDate = (year, month, date) => {
  const builtDate = new Date(year, month, date);
  return (
    builtDate.getFullYear() === year &&
    builtDate.getMonth() === month &&
    builtDate.getDate() === date
  );
};

// calculate age from date
export const calculateAge = (dob) => {
  const diff_ms = Date.now() - dob.getTime();
  const age_dt = new Date(diff_ms);

  return Math.abs(age_dt.getFullYear() - 1970);
};

// mask email
export const maskEmail = (str) => {
  const mask = (part) => {
    const strLen = part.length;
    if (strLen > 2) {
      return (
        part.substr(0, 1) +
        part.substr(2, strLen - 1).replace(/\w/g, "*") +
        part.substr(-1, 1)
      );
    }
    return part.replace(/\w/g, "*");
  };
  return str.replace(
    /([\w.]+)@([\w-.]+)(\.[\w-.]+)/g,
    (_, p1, p2, p3) => mask(p1) + "@" + mask(p2) + p3
  );
};

// mask phone number
export const maskPhoneNumber = (str) => {
  return `******${str.substring(str.length - 4)}`;
};

// convert s(seconds) to mm:ss(minute:seconds)
export const secondsToMinuteSeconds = (e) => {
  const m = Math.floor((e % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(e % 60)
    .toString()
    .padStart(2, "0");

  return m + ":" + s;
};

//returns dd
const dd_form = (originalDate) => {
  return `${originalDate.getDate() < 10
    ? `0${originalDate.getDate()}`
    : originalDate.getDate()
    }`;
};

//returns mm
const mm_form = (originalDate) => {
  return `${originalDate.getMonth() + 1 < 10
    ? `0${originalDate.getMonth() + 1}`
    : originalDate.getMonth() + 1
    }`;
};

//returns yyyy
const yyyy_form = (originalDate) => {
  return `${originalDate.getFullYear()}`;
};

//date to yyyymmdd format
export const dateToyyyymmdd = (originalDate, seperator) => {
  const convertedDate = `${yyyy_form(originalDate)}${seperator}${mm_form(
    originalDate
  )}${seperator}${dd_form(originalDate)}`;
  return convertedDate;
};

//yyyymmdd string to date, month, year
export const yyymmddStrSplit = (str, seperator) => {
  const splittedArr = str ? str.split(seperator) : [];
  const date = Number(splittedArr[2]) || 1;
  const month = Number(splittedArr[1]) || 1;
  const year = Number(splittedArr[0]) || 2000;
  return { date, month, year };
};

// save lead in Cookie
export const saveLeadCookie = (lead) => {
  document.cookie = `lead=${lead}; path=/; SameSite=None; Secure`;
};

// remove lead in Cookie
export const removeLeadCookie = () => {
  document.cookie = `lead=; path=/; max-age=${0}`;
};

// Get lead from cookie
export const getLeadFromCookie = () => {
  const cookieRoleId = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith("lead="));
  const lead = cookieRoleId ? cookieRoleId.substring(5) : undefined;

  return lead === "null" ? null : lead;
};

// save qr in cookie
export const saveQrinCookie = (qr) => {
  document.cookie = `qr=${qr}; path=/; SameSite=None; Secure`;
};

// remove qr from cookie
export const removeQrFromCookie = () => {
  document.cookie = `qr=; path=/; max-age=${0}`;
};

// Get qr from cookie
export const getQrFromCookie = () => {
  const cookieQr = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith("qr="));
  const qr_code = cookieQr ? cookieQr.substring(3) : undefined;
  return qr_code;
};

// save url in cookie
export const saveUrlinCookie = (url) => {
  document.cookie = `url=${url}; path=/; SameSite=None; Secure`;
};

// remove url from cookie
export const removeUrlFromCookie = () => {
  document.cookie = `url=; path=/; max-age=${0}`;
};

// Get url from cookie
export const getUrlFromCookie = () => {
  const cookieUrl = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith("url="));
  const url_link = cookieUrl ? cookieUrl.substring(4) : undefined;
  return url_link;
};

// save urlSegment in cookie
export const saveUrlSegmentInCookie = (urlSegment) => {
  document.cookie = `urlSegment=${urlSegment}; path=/; SameSite=None; Secure`;
};

// remove urlSegment from cookie
export const removeUrlSegmentFromCookie = () => {
  document.cookie = `urlSegment=; path=/; max-age=${0}`;
};

// save productType in cookie
export const saveCreditCardDetailsInCookie = (details, security) => {
  document.cookie = `CCDetails${security}=${JSON.stringify(details)}; path=/; SameSite=None; Secure`;
};

// remove productType from cookie
export const removeCreditCardDetailsFromCookie = () => {
  document.cookie = `CCDetailssecured=; path=/; max-age=${0}`;
  document.cookie = `CCDetailsunsecured=; path=/; max-age=${0}`;
};

// Get productType from cookie
export const getCreditCardDetailsFromCookie = (security) => {
  const cookieCCDetails = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith(`CCDetails${security}=`));
  const CCDetails = cookieCCDetails
    ? JSON.parse(cookieCCDetails.substring(`CCDetails${security}=`.length))
    : [];
  return CCDetails;
};

// clear cookie data saved by app
export const clearCookieData = async () => {
  await removeCookieAsync("atkn");
  await removeCookieAsync("prospectAppId");
  await removeCookieAsync("appId");
  await removeCookieAsync("productId");
  await removeCookieAsync("productType");
  await removeCookieAsync("utms");
  await removeCookieAsync("urlSegment");
  removeCreditCardDetailsFromCookie(); // removing Credit card details from cookie
};

// save AdminId in cookie
export const saveAdminIdInCookie = (adminId) => {
  document.cookie = `adminId=${adminId}; path=/; SameSite=None; Secure`;
};

// remove AdminId from cookie
export const removeAdminIdFromCookie = () => {
  document.cookie = `adminId=; path=/; max-age=${0}`;
};

// Get AdminId from cookie
export const getAdminIdFromCookie = () => {
  const cookieAdminId = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith("adminId="));
  const adminId = cookieAdminId ? cookieAdminId.substring(8) : undefined;
  return adminId;
};

export const saveMasqueradeModeInCookie = (isMasqueradeMode) => {
  document.cookie = `isMasqueradeMode=${isMasqueradeMode}; path=/; SameSite=None; Secure`;
};

export const getMasqueradeModeFromCookie = () => {
  const cookieIsMasqueradeMode = document.cookie
    .split("; ")
    .find((pair) => pair.startsWith("isMasqueradeMode="));

  const isMasqueradeMode = cookieIsMasqueradeMode
    ? cookieIsMasqueradeMode.split("=")[1]
    : undefined;

  return isMasqueradeMode;
};

export const removeMasqueradeModeFromCookie = () => {
  document.cookie = `isMasqueradeMode=; path=/; max-age=${0}`;
};


// get current user geolocation
export const getGeoLocation = () => {
  return new Promise(function (resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  })
    .then((res) => res.coords)
    .catch(() => -1);
};

// get current browser name
export const getCurrentBrowserName = () => {
  if (
    (navigator.userAgent.indexOf("Opera") ||
      navigator.userAgent.indexOf("OPR")) != -1
  ) {
    return "Opera";
  } else if (navigator.userAgent.indexOf("Edg") != -1) {
    return "Edge";
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    return "Safari";
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return "Firefox";
  } else if (
    navigator.userAgent.indexOf("MSIE") != -1 ||
    !!document.documentMode == true
  ) {
    //IF IE > 10
    return "IE";
  } else {
    return "unknown";
  }
};

export const applySorting = (records, orderBy, order) => {
  return records.sort((a, b) => {
    const aValue =
      typeof a[orderBy] === "string" ? a[orderBy].toLowerCase() : a[orderBy];
    const bValue =
      typeof b[orderBy] === "string" ? b[orderBy].toLowerCase() : b[orderBy];
    if (
      (order === "desc" && bValue < aValue) ||
      (order === "asc" && bValue > aValue)
    ) {
      return -1;
    }
    if (
      (order === "asc" && bValue > aValue) ||
      (order === "desc" && bValue < aValue)
    ) {
      return 1;
    }
    return 0;
  });
};

// download blob file
export const downloadBlobFile = (blob, type, fileName = "download") => {
  const blobObj = new Blob([blob], {
    type,
  });
  const link = document.createElement("a");
  link._target = "_blank";
  link.href = window.URL.createObjectURL(blobObj);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// sleep execution for give "ms"
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

// check user route
export const isUserRoute = () => {
  const paths = window.location.pathname.split("/");
  return paths[1] === "user";
};

// check admin route
export const isAdminRoute = () => {
  const paths = window.location.pathname.split("/");
  return paths[1] === "admin";
};

// check admin route
export const isPartnerRoute = () => {
  const paths = window.location.pathname.split("/");
  return paths[1] === "partner";
};

// get current user ip address
export const getIpAddress = async () => {
  try {
    const response = await axios.get(`${endpoint}/api/get-client-ip`);
    return response.data.ip;
  } catch (error) {
    return null;
  }
};

export const isPartnerAvailable = () => {
  const partner_name = process.env.REACT_APP_PARTNER_API_NAME;
  return partnersList.includes(partner_name);
};

export const pixelTrackingEvent = (trackingPayload) => {
  if (process.env.REACT_APP_ENV === "PROD") {
    let pixelScript = document.createElement("script");
    pixelScript.innerHTML = `getProductData(${JSON.stringify(
      trackingPayload
    )})`;
    document.body.appendChild(pixelScript);
  }
};

export const getDate = (daysOff = 0) => {
  const today = new Date();

  const daysOffDate = new Date(today);
  daysOffDate.setDate(today.getDate() - daysOff);

  const formattedDate = daysOffDate.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  return formattedDate
}

export const priorDaysList = [
  {
    label: "Yesterday",
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toLocaleDateString("fr-CA"),
    endDate: new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toLocaleDateString("fr-CA"),
    value: "yesterday",
  },
  {
    label: "Last 7 Days",
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("fr-CA"),
    endDate: new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toLocaleDateString("fr-CA"),
    value: "last_7_days",
  },
  {
    label: "Last 30 Days",
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 30)
    ).toLocaleDateString("fr-CA"),
    endDate: new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toLocaleDateString("fr-CA"),
    value: "last_30_days",
  },
  {
    label: "Custom Range",
    startDate: "",
    endDate: "",
    value: "custom_range",
  },
];

export const numberFormat = (number) => {
  let nf = new Intl.NumberFormat("hi-IN", {
    style: "currency",
    currency: "INR",
  });
  return nf.format(number);
};

export const encrypt = (key) => {
  return btoa(key);
}

export const decrypt = (key) => {
  return atob(key);
}

export const flattenArray = (arr, key) => {
  const result = [];

  arr.forEach(item => {
    result.push(item);

    if (item[key]) {
      result.push(...item[key]);
    }
  });

  return result;
}

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
};


export const isPrimaryDomain = !process.env.REACT_APP_PRODUCT_TYPE && !process.env.REACT_APP_SUBDOMAIN


// Server side cookie management
export const saveCookieAsync = async (name, token, minutes = 60) => {
  await axios.post(`${endpoint}/api/cookies/save`, {
    name: name,
    value: token.toString(),
    minutes
  });
};

export const getCookieAsync = async (name) => {
  try {
    const { data } = await axios.get(`${endpoint}/api/cookies/read`, {
      params: {
        name
      }
    });
    return data.value;
  } catch (error) {
    console.error("Error in API: ", error);
    return null;
  }
};

export const removeCookieAsync = async (name) => {
  await axios.post(`${endpoint}/api/cookies/delete`, {
    name
  });
};

// clear admin cookie data saved by app
export const clearAdminCookieData = async () => {
  await removeCookieAsync("a_atkn")
  await removeCookieAsync("adminId");
  await removeCookieAsync("roleId");
};

// clear admin cookie data saved by app
export const clearPartnerCookieData = async () => {
  await removeCookieAsync("p_atkn");
  await removeCookieAsync("partnerId");
  await removeCookieAsync("isPartner");
};